import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=582a8ef7&"
import script from "./CollapseButton.vue?vue&type=script&lang=js&"
export * from "./CollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./CollapseButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CollapseButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports